import { render, staticRenderFns } from "./ProductionItemsPerStatus.vue?vue&type=template&id=f3280e98"
import script from "./ProductionItemsPerStatus.vue?vue&type=script&lang=js"
export * from "./ProductionItemsPerStatus.vue?vue&type=script&lang=js"
import style0 from "./ProductionItemsPerStatus.vue?vue&type=style&index=0&id=f3280e98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports